import { sanitizeAndDecodeHtml } from "@/utils/helper"

const NotifySuccess = props => {
  const { staticTexts } = props
  return (
    <div className="success-message">
      <p className="thank-title">{staticTexts.thanksMessage}</p>
      <p className="thank-title">
        {sanitizeAndDecodeHtml(staticTexts.successMsg)}
      </p>
    </div>
  )
}

export default NotifySuccess
